'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Edition = require('./components/Edition.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Edition).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-edition/lib/index.js
// module id = 1479
// module chunks = 1